<template>
    <pappas-reservation-form :api-base="dashboardApiBase" :checkbox-component="CheckboxInput" :open-table-widget-config="openTableConfig" :radio-component="RadioInput" :submit-button-component="SubmitButton" enhanced-select :display-sidebar="false" :include-styles="false" private-event-url-target="_blank"></pappas-reservation-form>
</template>

<script setup>
import CheckboxInput from '../Forms/CheckboxInput.vue';
import RadioInput from './RadioInput.vue';
import SubmitButton from '../Forms/SubmitButton.vue';

defineProps({ dashboardApiBase: { type: String, default: 'https://dashboard.pappas.com/api' } });

const openTableConfig = {
    primary_font_color: '545e67',
    button_color: 'adebec',
    button_font_color: '002649',
};
</script>

